import { SequenceNodeType } from "@/@types/flows/sequences";

const addNodeOptions: { type: SequenceNodeType; text: string }[] = [
  {
    type: SequenceNodeType.TimeInterval,
    text: "Intervalo de tiempo",
  },
  {
    type: SequenceNodeType.AutomaticCall,
    text: "Llamada automática",
  },
];

const addNodeOptionsMultichannel: { type: SequenceNodeType; text: string }[] = [
  {
    type: SequenceNodeType.TimeInterval,
    text: "Intervalo de tiempo",
  },
  {
    type: SequenceNodeType.AutomaticCall,
    text: "Llamada automática",
  },
  {
    type: SequenceNodeType.Email,
    text: "Correo electrónico",
  },
  {
    type: SequenceNodeType.Whatsapp,
    text: "Mensaje de Whatsapp",
  },
  {
    type: SequenceNodeType.Sms,
    text: "Mensaje de SMS",
  },
];

export { addNodeOptions, addNodeOptionsMultichannel };
